import { type ReactElement } from 'react'
import { useTeamHierarchyContext } from '../../TeamHierarchyContext'
import { BasicNode } from './BasicNode'
import { EditableNode } from './EditableNode'
import { PermissionNode } from './PermissionNode'
import { type TeamNodeContentProps } from './types'

export const TeamNodeContent = (props: TeamNodeContentProps): ReactElement => {
  const { withPermissions, canEdit } = useTeamHierarchyContext()

  if (withPermissions) return <PermissionNode {...props} />

  if (!canEdit) return <BasicNode {...props} />

  return <EditableNode {...props} />
}
